import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DashboardLayout from '../../components/DashboardLayout';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { toast } from 'sonner';
import { BookOpen, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SpecialArabic = () => {
    const [rows, setRows] = useState(null);
    useEffect(() => {
        axios.get(`${API_URL}/api/special-arabic/mine`, { withCredentials: true }).then(r => setRows(r.data || []))
            .catch(e => { toast.error(e.response?.data?.detail || 'Failed to load'); setRows([]); });
    }, []);
    return (
        <DashboardLayout>
            <div className="space-y-6" data-testid="special-arabic-page">
                <div><h1 className="text-2xl font-bold text-[#1F2937] font-['Outfit'] flex items-center gap-2"><BookOpen className="h-6 w-6 text-[#D97706]" />Special Arabic Class</h1>
                    <p className="text-[#4B5563]">Students assigned to you for Special Arabic, with their program, class and main teacher</p></div>
                <Card className="card-surface"><CardContent className="p-0">
                    {rows === null ? <div className="flex justify-center p-10"><Loader2 className="h-6 w-6 animate-spin text-[#064E3B]" /></div>
                        : rows.length === 0 ? <p className="p-10 text-center text-sm text-[#6B7280]" data-testid="special-arabic-empty">No students assigned to you yet.</p> : (
                            <Table>
                                <TableHeader><TableRow><TableHead>Student</TableHead><TableHead>Program</TableHead><TableHead>Class</TableHead><TableHead>Main teacher</TableHead><TableHead>Arabic book</TableHead></TableRow></TableHeader>
                                <TableBody>
                                    {rows.map(r => (
                                        <TableRow key={r.id} data-testid={`special-arabic-row-${r.id}`}>
                                            <TableCell><p className="font-medium">{r.name}</p><p className="text-xs text-[#6B7280]"><span dir="rtl">{r.arabic_name}</span> <span className="font-mono">{r.reg_code || ''}</span></p></TableCell>
                                            <TableCell><Badge variant="outline">{r.program_name}</Badge></TableCell>
                                            <TableCell>{r.class_name}{r.arabic_class && <span className="text-xs text-[#6B7280] ml-1" dir="rtl">{r.arabic_class}</span>}</TableCell>
                                            <TableCell>{r.main_teacher || '—'}</TableCell>
                                            <TableCell className="font-medium text-[#B45309]">{r.book || '—'}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        )}
                </CardContent></Card>
            </div>
        </DashboardLayout>
    );
};

export default SpecialArabic;
